import React from 'react';
import buttonImage from '../buttonimage.webp';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';
import mirrorimage from '../mirrorimage.webp';
import { supabase } from '../supabaseClient';

function Honor({ goBack, goHome }) {
    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                alert('User not logged in!');
                return;
            }
            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'honor',
                    animated_helper: 'no',
                    timestamp: new Date().toISOString(),
                });
            if (progressError) {
                alert('Failed to save progress: ' + progressError.message);
                return;
            }
            alert('Session progress has been saved successfully!');
        } catch (err) {
            alert('An unexpected error occurred while saving progress.');
        }
    };

    return (
        <div style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '16px',
        }}>
            {/* Title */}
            <h3 style={{
                fontFamily: 'Times New Roman, Times, serif',
                fontSize: '24px',
                fontWeight: 'bold',
                color: 'black',
                marginBottom: '32px',
            }}>
                Honor
            </h3>

            {/* Mirror Image Card */}
            <div
                style={{
                    width: '100%',
                    maxWidth: '600px',
                    borderRadius: '10px',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    border: '2px solid black',
                    marginBottom: '24px',
                    marginTop: 0,
                    overflow: 'hidden',
                    background: 'transparent',
                }}
            >
                <img
                    src={mirrorimage}
                    alt="Mirror"
                    style={{
                        width: '100%',
                        borderRadius: '10px 10px 0 0',
                        objectFit: 'cover',
                        maxHeight: '220px',
                    }}
                />
                <div
                    style={{
                        backgroundImage: `url(${cardBackgroundImage})`,
                        backgroundSize: 'cover',
                        borderBottomLeftRadius: '10px',
                        borderBottomRightRadius: '10px',
                        padding: '24px',
                        textAlign: 'center',
                    }}
                >
                    <div style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '22px',
                        fontWeight: 'bold',
                        color: '#4B5563',
                        margin: '0 0 8px 0',
                        textAlign: 'center',
                    }}>
                        Honor
                    </div>
                    <div style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: '#333',
                        textAlign: 'center',
                    }}>
                        Honor begins with seeing the value in ourselves.
                    </div>
                </div>
            </div>

            {/* Session Helper Cards Row */}
            <div
                className="honor-session-helper-row"
                style={{
                    display: 'flex',
                    flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                    gap: '16px',
                    width: '100%',
                    maxWidth: '600px',
                    marginBottom: '16px',
                }}
            >
                {/* Left Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>• Pride takes full credit for ourselves, while honor recognizes something bigger than us.</div>
                        <div>• Pride can make it our fault and think it is all up to us, while honor recognizes the divine orchestration that it took to make it all come together.</div>
                        <div>• To Honor is to hold with high regard</div>
                        <div>• Honor takes all aspects into appreciation and acknowledgement</div>
                        <div>• Honoring self is a recognition that you are enough and that you are sovereign</div>
                        <div>• Honor feels good.  It allows you to go through whatever process life has you in without worrying about what it means about you</div>
                    </div>
                </div>
                {/* Right Card */}
                <div style={{
                    flex: 1,
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'left',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                    <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                        <div>1. What does it mean to you to honor yourself?</div>
                        <div>2. Can you see how Honor is a higher vibration than pride?</div>
                        <div>3. What is one way you can honor yourself now?</div>
                        <div>4. Is there anything that you would like to let go of in order to honor yourself more?</div>
                        <div>5. Where can you upgrade your pride to honor?</div>
                        <div>6. Is there any part of yourself or your life that you are not honoring?</div>
                    </div>
                </div>
            </div>

            {/* New Card below the two side-by-side cards, above the column */}
            <div style={{
                width: '100%',
                maxWidth: '600px',
                border: '2px solid black',
                borderRadius: '10px',
                padding: '16px',
                textAlign: 'center',
                backgroundImage: `url(${cardBackgroundImage})`,
                backgroundSize: 'cover',
                boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                marginBottom: '16px'
            }}>
                <p style={{
                    fontFamily: 'Times New Roman, Times, serif',
                    fontSize: '16px',
                    color: 'black',
                    margin: 0
                }}>
                    I had a friend who has since passed on, and she is the one who introduced me to the concept of honor above pride.  To be honest when she said it to me, I tried it on and did not really trust that it was true. It was not until many years later, after she had passed on that it became clear to me.  Pride is not wrong.  It is important to have a sense of self and and to relate to the world with respect to our own sense of self.  Pride can make it all about us, but it can also give us the experience of being pleased with ourselves, either for a reason or for no reason at all.  These things are not wrong.  Its just that honor is above our need to self identify in a way, but it does account for us as our own soveriegn person.  Honor is like knowing that I am a part of the divine orchestration of this universe, I am here for a reason, I am part of the all, and I understand that I do not know it all, but that I have my part to play. <br />   We are each working with the wisdom we have gained from our lived life experiences and the knowledge we have learned from outside of ourselves.  While knowledge is important because we learn about the world and other people's perspectives. Our wisdom gained is customized to our life experiences and what we have come to experience as a soul.  That is my take on it anyway. Having our own perspective and understanding ourselves within the context of our own experiences seems to be the one superpower we each have and cannot outsource.  
                </p>
            </div>

            {/* Cards */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '16px',
                width: '100%',
                maxWidth: '600px',
            }}>
                {/* Card 1 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    minHeight: '260px', // Make card taller for image
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start'
                }}>
                    <img
                        src="/images/reflectionquestionactivity.webp"
                        alt="Reflection Activity Have I honored myself today?"
                        style={{
                            width: '100%',
                            height: 'auto',
                            maxHeight: '220px',
                            objectFit: 'contain',
                            borderRadius: '8px',
                            marginBottom: '12px'
                        }}
                    />
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        Reflect on the importance of honoring yourself.
                    </p>
                </div>
                {/* Card 2 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <img
                        src="/images/forgiveness.webp"
                        alt="It is not our job to hold a grudge against ourselves for every mistake or failure we experience.  We are meant to Forgive ourselves, and offer Unconditional Love to ourselves.  We honor the Journey when we Use what we learn. Nothing is unforgiveable"
                        style={{
                            width: '100%',
                            height: 'auto',
                            maxHeight: '220px',
                            objectFit: 'contain',
                            borderRadius: '8px',
                            marginBottom: '12px'
                        }}
                    />
                    <p style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        color: 'black',
                    }}>
                        Honor says, whatever experiences we have, whatever mistakes we make, it is all part of our journey and is to be honored as such.
                    </p>
                </div>

                {/* Card 3 */}
                <div style={{
                    width: '100%',
                    border: '2px solid black',
                    borderRadius: '10px',
                    padding: '16px',
                    textAlign: 'center',
                    backgroundImage: `url(${cardBackgroundImage})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                }}>
                    <iframe
                        width="100%"
                        height="315"
                        src="https://www.youtube.com/embed/7LjY77Gi1S0?si=DuCdSE1YyyWsNxXy"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                        style={{
                            borderRadius: '10px',
                            maxWidth: '100%',
                            minHeight: '200px'
                        }}
                    ></iframe>
                </div>
            </div>
            {/* Navigation Buttons */}
            <div
                className="honor-nav-btn-row"
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '16px',
                    marginTop: '32px',
                    marginBottom: '16px',
                }}
            >
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={goBack}
                >Back</button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={goHome}
                >Home</button>
                <button
                    style={{
                        backgroundImage: `url(${buttonImage})`,
                        backgroundSize: 'cover',
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '10px 20px',
                        width: '120px',
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}
                    onClick={handleSaveProgress}
                >Save</button>
            </div>
            <style>
                {`
                @media (max-width: 600px) {
                    .honor-nav-btn-row {
                        position: static !important;
                        width: 100%;
                        background: none;
                        border-top: none;
                        border-radius: 0;
                        box-shadow: none;
                        padding: 0;
                        z-index: auto;
                        display: flex;
                        justify-content: center;
                        gap: 10px;
                        margin-top: 32px !important;
                        margin-bottom: 16px !important;
                    }
                    .honor-image-card img {
                        max-height: 180px !important;
                        height: auto !important;
                    }
                    .honor-image-card {
                        min-height: 200px !important;
                    }
                    body {
                        padding-bottom: 0 !important;
                    }
                }
                `}
            </style>
        </div>
    );
}

export default Honor;
